import {
  Avatar,
  Skeleton,
  skeletonize,
} from "@songtradr-one/components-frontend";
import { Flex } from "@songtradr-one/shared-frontend";
import { Wrapper } from "./NotificationItem.Parts";

const AvatarSkeleton = skeletonize(Avatar);

export const NotificationItemSkeleton = () => (
  <Wrapper $clickable={false}>
    <AvatarSkeleton height="2rem" width="2rem" />
    <Flex $flow="column" $gap="0.5rem" $flex="1" $minWidth="0">
      <Skeleton $height="1.25rem" $width="80%" />
      <Skeleton $height="1rem" $width="100%" />
      <Skeleton $height="0.75rem" $width="25%" />
    </Flex>
  </Wrapper>
);
